var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenseTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    rx: 20,
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 500,
    height: 300,
    rx: 10,
    fill: "#FFFFFF",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 120,
    width: 40,
    height: 180,
    rx: 5,
    fill: "#A66EFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 150,
    width: 40,
    height: 150,
    rx: 5,
    fill: "#6A11CB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 100,
    width: 40,
    height: 200,
    rx: 5,
    fill: "#A66EFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 180,
    width: 40,
    height: 120,
    rx: 5,
    fill: "#6A11CB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 130,
    width: 40,
    height: 170,
    rx: 5,
    fill: "#A66EFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 160,
    width: 40,
    height: 140,
    rx: 5,
    fill: "#6A11CB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 90,
    width: 40,
    height: 210,
    rx: 5,
    fill: "#A66EFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 70,
    width: 450,
    height: 30,
    rx: 5,
    fill: "#FFFFFF",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 60,
    fill: "#FFFFFF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 160V240M285 170H310C317.5 170 325 177.5 325 185C325 192.5 317.5 200 310 200H290C282.5 200 275 207.5 275 215C275 222.5 282.5 230 290 230H315",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 600,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A11CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2575FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseTracker);
export default __webpack_public_path__ + "static/media/expense-tracker.5013bf3a14e02845698ea5671769792d.svg";
export { ForwardRef as ReactComponent };